import React from 'react'
import CheckMark from '../../assets/icons/checkmark.svg'

const CheckBox = props => {
  const className = props.isLoading
    ? 'btn btn-checkbox loading'
    : props.checked
    ? 'btn btn-checkbox checked'
    : 'btn btn-checkbox'

  return (
    <button
      onClick={props.onClick}
      className={className}
      disabled={props.disabled || props.isLoading}
      id={props.id}
      aria-busy={props.isLoading || undefined}
    >
      {props.isLoading ? (
        <span className="btn-checkbox-spinner" aria-hidden="true" />
      ) : (
        props.checked && <img src={CheckMark} alt="checked" />
      )}
    </button>
  )
}

export default CheckBox
